<template>
  <div>
    <web-chart
      :categories="categories"
      :series="series"
      :chartStyles="{chordStep: 10, areaFillColor: 'transparent', areas, width, height}"
    >
      <template v-slot:area></template>
      <template v-slot:label="label">
        <span
          class="d-flex align-items-center"
          v-b-tooltip.hover :title="categories[label.index].name"
        >
          <i
            class="lgf mr-2 fs-240"
            :class="categories[label.index].icon"
          />
        </span>
      </template>
    </web-chart>
  </div>
</template>
<script>
  import WebChart from '../../common/charts/WebChart'
  import { Color } from '../../../utils/Color'
  import { dimensions } from '../../../utils/Dimensions'

  export default {
    components: {
      WebChart
    },
    props: {
      width: {
        type: Number,
        default: 439
      },
      height: {
        type: Number,
        default: 400
      },
      tests: {
        type: Array,
        required: true,
        default: () => ([])
      },
      display: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    computed: {
      categories() {
        return dimensions
      },
      series() {
        return _.map(this.tests, test => test.dimensions !== null ? test.dimensions : [])
      },
      areas() {
        return _.map(this.tests, (test, index) => {
          if(!this.display[test.id].visible) {
            return {
              display: 'none'
            }
          } else if(test.is_control) {
            return {
              stroke: 'var(--lingusta-green)',
              fill: 'var(--lingusta-green)',
              opacity: '0.8'
            }
          } else {
            return {
              stroke: Color.action(test.action.id).toString()
            }
          }
        })
      }
    },
    methods: {
      tooltipLines(aIndex) {
        var lines = []
        _.forEach(this.series[aIndex], (dimension, index) => {
          lines.push({
            label: this.categories[index].name,
            value: dimension.value
          })
        })
        return lines
      },
    }
  }
</script>